// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".legacy." + {"252":"9f414d0b9515442bcb1c","327":"901c773de4bd5cef827a","331":"56fdaba33e09f5f846ea","348":"2350b787a0fbbb3a3959","413":"43915284403a8b079580","433":"b57e75d02c5bd193daeb","624":"6fef367f0fa4b263ebc6","790":"5855dfcecdb5aac38dc6"}[chunkId] + ".js";
};